// removed by extract-text-webpack-plugin
module.exports = {"buttons":"buttons_3hKWq","inner":"inner_1opeF"};


//////////////////
// WEBPACK FOOTER
// ./app/components/spread-extra-buttons/styles.scss
// module id = 515
// module chunks = 1